import { ActionKey, PlanPermissions, ResourceKey, ResourcePermissions } from "data/models";
import _ from "lodash";


export type PermissionsKey = {
  resource: ResourceKey;
  action: ActionKey;
  resourceDisplay: string;
  actionDisplay: string;
};

function createPermission(resource: ResourceKey, action: ActionKey): PermissionsKey {
  const toDisplay = (s: string) => _.startCase(s.toLowerCase());

  return {
    resource: resource,
    action: action,
    resourceDisplay: toDisplay(resource),
    actionDisplay: toDisplay(action),
  };
}

export const PermissionsKeys = {
  subscriptionCreate: createPermission("subscription", "create"),
  subscriptionRead: createPermission("subscription", "read"),
  subscriptionUpdate: createPermission("subscription", "update"),
  subscriptionDelete: createPermission("subscription", "delete"),
  paymentMethodCreate: createPermission("payment_method", "create"),
  paymentMethodRead: createPermission("payment_method", "read"),
  paymentMethodUpdate: createPermission("payment_method", "update"),
  paymentMethodDelete: createPermission("payment_method", "delete"),
  overageCreate: createPermission("overage", "create"),
  overageRead: createPermission("overage", "read"),
  overageUpdate: createPermission("overage", "update"),
  overageDelete: createPermission("overage", "delete"),
  appsCreate: createPermission("apps", "create"),
  appsRead: createPermission("apps", "read"),
  appsUpdate: createPermission("apps", "update"),
  appsDelete: createPermission("apps", "delete"),
  clipCreate: createPermission("clip", "create"),
  clipRead: createPermission("clip", "read"),
  clipUpdate: createPermission("clip", "update"),
  clipDelete: createPermission("clip", "delete"),
  batchCreate: createPermission("batch", "create"),
  batchRead: createPermission("batch", "read"),
  batchUpdate: createPermission("batch", "update"),
  batchDelete: createPermission("batch", "delete"),
  premiumDataCreate: createPermission("premium_data", "create"),
  premiumDataRead: createPermission("premium_data", "read"),
  premiumDataUpdate: createPermission("premium_data", "update"),
  premiumDataDelete: createPermission("premium_data", "delete"),
  groupsCreate: createPermission("groups", "create"),
  groupsRead: createPermission("groups", "read"),
  groupsUpdate: createPermission("groups", "update"),
  groupsDelete: createPermission("groups", "delete"),
  rolesCreate: createPermission("roles", "create"),
  rolesRead: createPermission("roles", "read"),
  rolesUpdate: createPermission("roles", "update"),
  rolesDelete: createPermission("roles", "delete"),
  permissionsCreate: createPermission("permissions", "create"),
  permissionsRead: createPermission("permissions", "read"),
  permissionsUpdate: createPermission("permissions", "update"),
  permissionsDelete: createPermission("permissions", "delete"),
  reportsCreate: createPermission("reports", "create"),
  reportsRead: createPermission("reports", "read"),
  reportsUpdate: createPermission("reports", "update"),
  reportsDelete: createPermission("reports", "delete"),
  membersCreate: createPermission("members", "create"),
  membersRead: createPermission("members", "read"),
  membersUpdate: createPermission("members", "update"),
  membersDelete: createPermission("members", "delete"),
} as const;
